var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBang = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.054,
  d: "m6.881 1.577.551 1.07a1.72 1.72 0 0 0 2.054.85l1.146-.367-.367 1.146a1.72 1.72 0 0 0 .85 2.054l1.07.55-.839.433a1.72 1.72 0 0 0-.743 2.313l1.024 2-2-1.024a1.72 1.72 0 0 0-2.314.744l-.432.839-.55-1.07a1.72 1.72 0 0 0-2.054-.85l-1.146.366.366-1.146a1.72 1.72 0 0 0-.85-2.053l-1.07-.551.839-.432a1.72 1.72 0 0 0 .743-2.313L2.135 2.135l2.001 1.024a1.72 1.72 0 0 0 2.313-.744z",
  opacity: 0.4
})));
export default SvgBang;